import React from 'react';
import SelfAssessmentTable from './components/SelfAssessmentTable';

function App() {
  return (
    <div className="App">
      <SelfAssessmentTable />
    </div>
  );
}

export default App;